<template>
  <form @submit.prevent="handleFormSubmit" class="form">
    <register-title class="form__title">Налоговая информация</register-title>
    <register-input
      v-model="form.individual_number"
      componentID="registration-document-number"
      label="Номер документа, подтверждающего регистрацию лица в качестве индивидуального предпринимателя"
      :isRequired="true"
      inputType="text"
      inputPlaceholder="Номер документа"
      class="form__input"
    />
    <register-input
      v-model="form.individual_issued_at"
      componentID="issue-date"
      inputType="date"
      :maxDate="new Date()"
      label="Дата выдачи"
      :isRequired="true"
      class="form__input"
    />
    <!--      v-model=""-->
    <!--    <register-input-->
    <!--      componentID="business-id-number"-->
    <!--      v-model="form.individual_bin"-->
    <!--      label="Бизнес-идентификационный номер"-->
    <!--      :isRequired="false"-->
    <!--      inputType="text"-->
    <!--      :inputMaxLength="12"-->
    <!--      inputPlaceholder="Бизнес-идентификационный номер"-->
    <!--      class="form__input"-->
    <!--    />-->
    <!--    <p-->
    <!--      class="login-form__error"-->
    <!--      v-if="-->
    <!--        form.individual_bin !== null &&-->
    <!--          form.individual_bin.length == 12 &&-->
    <!--          !validateIin(form.individual_bin)-->
    <!--      "-->
    <!--    >-->
    <!--      Неверный БИН-->
    <!--    </p>-->
    <register-input
      v-model="form.individual_activity_type"
      componentID="business-type"
      label="Вид предпринимательской деятельности"
      :isRequired="true"
      inputType="text"
      inputPlaceholder="Вид предпринимательской деятельности"
      class="form__input"
    />
    <register-input
      v-model="form.individual_license_number"
      componentID="license-number"
      label="Номер лицензии"
      :isRequired="false"
      inputType="text"
      inputPlaceholder="Номер лицензии"
      class="form__input"
    />
    <register-input
      v-model="form.individual_license_issued_at"
      inputType="date"
      componentID="license-issue-date"
      label="Дата выдачи лицензия"
      :maxDate="new Date()"
      :isRequired="false"
      class="form__input"
    />
    <register-input
      v-model="form.individual_license_valid_till"
      inputType="date"
      componentID="license-validity-date"
      label="Срок действия лицензии"
      :minDate="new Date()"
      :isRequired="false"
      class="form__input"
    />
    <register-input
      v-model="form.individual_business_address"
      componentID="address"
      label="Адрес места осуществления предпринимательской деятельности"
      :isRequired="false"
      inputType="text"
      inputPlaceholder="Адрес"
      class="form__input"
    />
    <button class="button filled form__button">Подтвердить</button>
  </form>
</template>

<script>
import { FhsAxios } from "../../../services/axios";
import RegFormMixin from "../form_mixin";
export default {
  props: ["user_profile"],
  data() {
    return {
      form: {
        individual_number: null,
        individual_issued_at: "",
        individual_activity_type: null,
        individual_license_number: null,
        individual_license_issued_at: "",
        individual_license_valid_till: "",
        individual_business_address: null
      },
      form_dates: [
        "individual_issued_at",
        "individual_license_issued_at",
        "individual_license_valid_till"
      ]
    };
  },
  mixins: [RegFormMixin],
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  methods: {
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        Object.entries(this.user_profile.userProfile).map(obj => {
          if (obj[0] in this.form) {
            this.form[obj[0]] = obj[1];
          }
        });
        this.form_dates.forEach(date => {
          this.form[date] = this.dateFormat(this.form[date]);
        });
        this.old_form = JSON.parse(JSON.stringify(this.form));
      } catch (e) {
        // ERROR HANDLER
      }
    },
    nextStep() {
      this.$router.push({ name: "representatives-info-list" });
    },
    saveData() {
      this.$emit("loading-status", true);
      const form = JSON.parse(JSON.stringify(this.form));
      this.form_dates.forEach(date => {
        form[date] = this.dateReFormat(form[date]);
      });
      let url = `user/profile`;
      FhsAxios.post(url, form).then(res => {
        if (res.data.status) {
          this.$toasted.success("Данные сохранены");
          this.nextStep();
          return;
        }
        this.$toasted.error("Произошла ошибка");
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (!this.isFormChanged()) {
        this.nextStep();
      } else {
        this.saveData();
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>

<style scoped>
.form__title {
  margin-bottom: 20px;
}

.form__input {
  margin-bottom: 15px;
}

.form__button {
  margin: 20px auto 0;
  padding: 15px 0;
  width: 100%;
}
</style>
